import Service from "../components/Service";

export default function ServiceRoute(){
  return (
    <>
    <Service />
    </>
  )
}